import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class LodashService {
  constructor() {
    Object.assign(this, _);
  }

  format() {
    var s = arguments[0];
    var words = _.tail(arguments);
    return _.reduce(
      words,
      function (s, w) {
        var i = s.indexOf('%s');
        return i >= 0 ? s.slice(0, i) + w + s.slice(i + 2) : s + ' ' + w;
      },
      s,
    );
  }
  guid() {
    let d = performance.now();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        // tslint:disable-next-line:no-bitwise
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      },
    );
    return uuid.toUpperCase();
  }

  guidLower() {
    return this.guid().toLowerCase();
  }

  coalesce(a: any[]): any {
    return _.first(_.compact(a));
  }

  stringifyNumber(nStr: any): string {
    let n = nStr;
    if (typeof n === 'string') {
      n = Number(n);
    }
    if (n < 10000) {
      n = Number(n.toPrecision(3));
      return this.addCommasToNumber(n, 1);
    } else if (n / 1000 < 10000) {
      n = Number((n / 1000).toPrecision(3));
      return this.addCommasToNumber(n, 1) + 'K';
    } else if (n / 1000000 < 10000) {
      n = Number((n / 1000000).toPrecision(3));
      return this.addCommasToNumber(n, 1) + 'M';
    } else if (n / 1000000000 < 10000) {
      n = Number((n / 1000000000).toPrecision(3));
      return this.addCommasToNumber(n, 1) + 'B';
    }
  }

  public jsonToRows(jsonData: any[]): any[] {
    const columns = _.keys(jsonData[0]);
    const rows = _.map(jsonData, function (o) {
      return _.values(o);
    });
    return _.union([columns], rows);
    // perhaps use _.zip with pluck? if the order is not good  zip is like pivoting
  }

  rowsToJson(rowData) {
    return _.map(_.tail(rowData), function (d) {
      return _.zipObject(rowData[0], d);
    });
  }

  timeIt(func, numTimes, callback) {
    const start = new Date().getTime();
    numTimes = numTimes || 1;
    for (let i = 0; i < numTimes; ++i) {
      func.call();
    }
    const end = new Date().getTime();
    const time = end - start;
    // alert('Execution time: ' + time);
    if (_.isFunction(callback)) {
      callback(time);
    }
  }

  shrink(jsonData: any[]) {
    if (jsonData.length > 0) {
      const keys = _.keys(jsonData[0]);
      const m = [];
      const mp = {};
      const mr = {};
      let mm;
      _.each(keys, function (k, i) {
        const v = this.distinct(jsonData, k); // value array
        const rr = _.range(v.length); // column id array
        mm = _.zip(rr, v); // map array
        m.push(mm); // map array
        mp[k] = {}; // object version of map array
        mr[k] = {}; // object version of map array
        _.each(mm, function (dd) {
          mp[k][dd[0]] = dd[1];
        }); // object version of map array
        _.each(mm, function (dd) {
          mr[k][dd[1]] = dd[0];
        }); // object version of map array reverse
      });
      // _.map(jsonData,function(d){return d})

      const r = _.range(keys.length);
      m.unshift(_.zip(r, keys)); // map array
      const d = [];
      _.each(jsonData, function (o, i) {
        d.push(
          _.map(o, function (dd, k) {
            return mr[k][dd];
          }),
        );
      });

      const shrunk = { m: m, mp: mp, mr: mr, d: d };
      return shrunk;
    } else {
      return false;
    }
  }

  /**
   * @method _.unshrink
   */
  unshrink(shrunkData) {
    const sd = shrunkData.d,
      m = shrunkData.m,
      mr = shrunkData.mr,
      mp = shrunkData.mp;

    const dd = [];
    _.each(sd, function (a) {
      const o = {};
      _.each(a, function (d, i) {
        const k = m[0][i][1];
        o[k] = mp[k][d];
      });
      dd.push(o);
    });

    return dd;
  }

  capitalizeWords(str: string) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  distinct(a, f) {
    // should be very fast, probably faster than underscore version.
    return _.sortBy(_.uniq(_.map(a, f)), _.identity);
  }

  param(obj) {
    const parts = [];
    for (const i in obj) {
      if (obj.hasOwnProperty(i)) {
        parts.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]));
      }
    }
    return parts.join('&');
  }

  moneyToBinary(m) {
    // convert decimal to binary with 20 places for the int and 6 for the decimal
    // ie 0.01 = 000.000001
    // 1.01 = 00000000000000000001.000001
    // 524288 = 10000000000000000000.000000
    // 524289.33 = 10000000000000000001.100001
    const dollars = m.toString().split('.')[0];
    const cents = _.padEnd(m.toString().split('.')[1], 2, '0');

    let binary =
      _.padStart(Math.floor(+m).toString(2), 20, '0') +
      _.padStart(
        parseInt(((32.1 % 1) * 100).toString(), 10).toString(2),
        6,
        '0',
      );
    binary =
      _.padStart((+dollars).toString(2), 20, '0') +
      _.padStart((+cents).toString(2), 6, '0');
    const indexes = _.compact(
      _.map(_.reverse(binary.split('')), function (d, i) {
        return +d ? i + 1 : null;
      }),
    );
    return { binary: binary, dollars: dollars, cnets: cents, indexes: indexes };
  }

  campaignToSummary(rs) {
    // get customconversions only
    const cc = _.map(rs.preload_data.insights.data, function (d) {
      d.actions = _.filter(d.actions, function (dd) {
        return dd.action_type.indexOf('custom') > 0;
      });
      d.action_values = _.filter(d.action_values, function (dd) {
        return dd.action_type.indexOf('custom') > 0;
      });
      d.actions = _.map(d.actions, function (dd) {
        dd = _.pick(dd, ['action_type', '28d_view', '28d_click']);
        dd = _.extend({ action_type: '', '28d_view': 0, '28d_click': 0 }, dd);
        dd['28d_click'] = +dd['28d_click'];
        dd['28d_view'] = +dd['28d_view'];
        dd.cnt = +dd['28d_view'] + +dd['28d_click'];
        return dd;
      });
      d.action_values = _.map(d.action_values, function (dd) {
        dd = _.pick(dd, ['action_type', '28d_view', '28d_click']);
        dd = _.extend({ action_type: '', '28d_view': 0, '28d_click': 0 }, dd);
        dd['28d_click'] = +dd['28d_click'];
        dd['28d_view'] = +dd['28d_view'];
        dd.total = +(+dd['28d_view'] + +dd['28d_click']).toFixed(2);
        return dd;
      });
      return d;
    });
    // bring the campaigns together and sum by flattening and grouping by action type.
    const r = {
      actions: _.map(
        _.groupBy(
          _.flatten(
            _.reduce(
              cc,
              function (o, d) {
                o.push(d.actions);
                return o;
              },
              [],
            ),
          ),
          'action_type',
        ),
        function (d, k) {
          return { action_type: k, cnt: _.sumBy(d, 'cnt') };
        },
      ),
      action_values: _.map(
        _.groupBy(
          _.flatten(
            _.reduce(
              cc,
              function (o, d) {
                o.push(d.action_values);
                return o;
              },
              [],
            ),
          ),
          'action_type',
        ),
        function (d, k) {
          return { action_type: k, total: _.sumBy(d, 'total') };
        },
      ),
    };
    // combine the actions and values together.
    return _.map(
      _.groupBy(_.union(r.actions, r.action_values), 'action_type'),
      function (a) {
        return _.pick(_.reduce(a, _.extend), ['action_type', 'cnt', 'total']);
      },
    );
  }

  dataToStackedBar(data, filters, chartsBy, groupedBy, stackedBy) {
    const colours = [
      '#97bbcd', // blue
      '#dcdcdc', // light grey
      '#f7464a', // red
      '#46bfbd', // green
      '#fdb45c', // yellow
      '#949fb1', // grey
      '#4d5360', // dark grey
    ];
    if (!chartsBy) {
      _.each(data, function (d) {
        return (d.dummy = 'dummy');
      });
      chartsBy = 'dummy';
    }
    const filteredData = this.applyAdvFilters(data, filters);
    // var filteredCnt = _.countByMulti(filteredData, ['group_name','incident_area', 'assigned_short']);
    const isStacked = true;
    const filteredCnt = this.countByMulti(filteredData, [
      chartsBy,
      stackedBy,
      groupedBy,
    ]);
    const filteredCnt2 = this.countByMulti(
      _.filter(filteredData, function (d) {
        return d.is_breakfix;
      }),
      [chartsBy, stackedBy, groupedBy],
    );
    let barinfo = {};
    _.each(filteredCnt, function (d, k) {
      const refilteredData = _.filter(filteredData, function (dd) {
        return dd[chartsBy] === k;
      });
      const labels = this.distinct(refilteredData, groupedBy);
      const series = this.distinct(refilteredData, stackedBy);
      const series_init = _.reduce(
        this.distinct(refilteredData, groupedBy),
        function (o, dd) {
          o[dd] = 0;
          return o;
        },
        {},
      );

      _.each(filteredCnt[k], function (ddd, kkk) {
        filteredCnt[k][kkk] = _.extend({}, series_init, ddd);
      });
      barinfo[k] = {
        barlabels: _.keys(series_init),
        barseries: _.keys(d),
        bardata: _.map(d, function (dd) {
          return _.values(dd);
        }),
        barlegend: true,
        baroptions: { stacked: isStacked, maintainAspectRatio: true },
        barcolours: colours,
      };
      // colours = (gp.chartsBy===gp.stackedBy)?_.union(_.rest(colours),[colours[0]]):colours;
    });
    if (chartsBy === 'dummy') {
      barinfo = barinfo['dummy'];
    }
    return barinfo;
  }

  groupByMulti(obj, values, context?) {
    return this.byMulti(obj, values, function (o) {
      return o;
    });
  }

  sumByMulti(obj, values, sumBy, context?) {
    return this.byMulti(obj, values, function (o) {
      return _.sum(_.compact(_.map(o, sumBy)));
    });
  }

  countByMulti(obj, values, context?) {
    return this.byMulti(obj, values, function (o) {
      return o.length;
    });
  }

  indexByMulti(obj, values, fieldFunction, context?) {
    if (_.isFunction(fieldFunction)) {
      return this.byMulti(obj, values, fieldFunction);
    } else {
      const field = fieldFunction;
      return this.byMulti(obj, values, function (o) {
        return _.isUndefined(fieldFunction) ? o[0] : o[0][field];
      });
    }
  }

  keyByMulti(obj, values, fieldFunction, context?) {
    if (_.isFunction(fieldFunction)) {
      return this.byMulti(obj, values, fieldFunction);
    } else {
      const field = fieldFunction;
      return this.byMulti(obj, values, function (o) {
        return _.isUndefined(fieldFunction) ? o[0] : o[0][field];
      });
    }
  }
  pivotByMulti(obj, values, fieldFunction, context?) {
    const distincts = _.reduce(
      values,
      (o, f) => {
        o[f] = this.distinct(obj, f);
        return o;
      },
      {},
    );
    const piv = this.indexByMulti(obj, values, fieldFunction);
    const base0 = _.reduce(
      distincts[values[0]],
      function (o, d) {
        o[d] = {};
        return o;
      },
      {},
    );
    let base1;
    if (_.isFunction(fieldFunction)) {
      base1 = _.reduce(
        distincts[values[1]],
        function (o, d) {
          o[d] = 0;
          return o;
        },
        {},
      );
    } else {
      base1 = _.reduce(
        distincts[values[1]],
        function (o, d) {
          o[d] = '';
          return o;
        },
        {},
      );
    }
    _.each(piv, function (d, k) {
      piv[k] = _.extend({}, base1, d);
    });
    _.each(base0, function (d, k) {
      return (base0[k] = piv[k]);
    });
    return base0;
  }

  byMulti(obj, values, leafFunction, context?) {
    if (!values.length) {
      return leafFunction(obj);
    }
    const byFirst = _.groupBy(obj, values[0]),
      rest = values.slice(1);
    for (const prop in byFirst) {
      byFirst[prop] = this.byMulti(byFirst[prop], rest, leafFunction, context);
    }
    return byFirst;
  }

  tinyDate(datetime) {
    return moment(datetime).format('MMM D, YY');
  }

  addCommasToNumber(nStr, places) {
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    let x2 = '';
    if (x.length > 1 && places > 0) {
      places = places || x[1].length;
      x2 = '.' + x[1].substr(0, places);
    }

    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  formatMoney(n, c, d, t) {
    c = isNaN((c = Math.abs(c))) ? 2 : c;
    d = d === undefined ? '.' : d;
    t = t === undefined ? ',' : t;
    const s = n < 0 ? '-' : '';
    const i = parseInt((n = Math.abs(+n || 0).toFixed(c)), 10) + '';
    let j;
    j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      s +
      (j ? i.substr(0, j) + t : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
      (c
        ? d +
          Math.abs(n - +i)
            .toFixed(c)
            .slice(2)
        : '')
    );
  }

  advFilter(jsonData, col, filters, callback?) {
    // based on filters in efApi
    filters = _.isArray(filters) || _.isFunction(filters) ? filters : [filters]; // make filters an array

    // this would add filters to it
    // this.filters[col]=(_.isUndefined(this.filters[col]))?filters:_.union(this.filters[col],filters);
    // merge in with existing filters if they exist
    // this just changes it.

    let fData: any[];
    if (_.isFunction(filters)) {
      fData = _.filter(jsonData, function (r) {
        return filters.call(this, r, r[col]);
      });
    } else {
      const isConditional =
        _.compact(
          _.map(filters, function (d, k) {
            return !_.isArray(d) && _.isObject(d) && !_.isFunction(d);
          }),
        ).length > 0;

      if (!isConditional) {
        const lcFilters = _.map(filters, function (d) {
          return String(d).toLowerCase();
        });
        fData = _.filter(jsonData, function (r) {
          return _.includes(lcFilters, String(r[col]).toLowerCase());
        });
      } else {
        // conditionals like nedb
        // will have the form [{$gt:0,$lt:10}]
        // since all the conditions are in one object it will be like an ANDing operation.
        // Multiple object would be ORing which is not supported currently.
        fData = jsonData;
        _.each(filters[0], function (v, k) {
          v = this.isNumeric(v) ? +v : v;
          v = v === 'CURRENT_TIMESTAMP' ? moment().format('YYYY-MM-DD') : v;
          let regex, lcFilters, match, numOf;
          switch (k) {
            case '$lt':
              fData = _.filter(fData, function (r) {
                return r[col] && r[col] < v;
              });
              break;
            case '$lte':
              fData = _.filter(fData, function (r) {
                return r[col] && r[col] <= v;
              });
              break;
            case '$gt':
              fData = _.filter(fData, function (r) {
                return r[col] && r[col] > v;
              });
              break;
            case '$gte':
              fData = _.filter(fData, function (r) {
                return r[col] && r[col] >= v;
              });
              break;
            case '$eq':
            case '$in':
              lcFilters = _.map(v, function (d) {
                return String(d).toLowerCase();
              });
              fData = _.filter(fData, function (r) {
                return _.includes(lcFilters, String(r[col]).toLowerCase());
              });
              break;
            case '$ne':
            case '$nin':
              lcFilters = _.map(v, function (d) {
                return String(d).toLowerCase();
              });
              fData = _.filter(fData, function (r) {
                return !_.includes(lcFilters, String(r[col]).toLowerCase());
              });
              break;
            case '$like':
            case '$regex':
              // fData = _.filter(fData, function (r) {return (String(r[col]).toLowerCase()).test(v); });
              if (v.indexOf('/') >= 0) {
                // already in regex format
                match = v.match(new RegExp('^/(.*?)/([gimy]*)$'));
                // sanity check here
                regex = new RegExp(match[1], match[2]);
              } else {
                regex = RegExp(v);
              }
              fData = _.filter(fData, function (r) {
                return r[col] && regex.test(String(r[col]));
              });
              break;
            case '$nlike':
              // fData = _.filter(fData, function (r) {return (String(r[col]).toLowerCase()).test(v); });
              if (v.indexOf('/') >= 0) {
                // already in regex format
                match = v.match(new RegExp('^/(.*?)/([gimy]*)$'));
                // sanity check here
                regex = new RegExp(match[1], match[2]);
              } else {
                // just as a string
                regex = RegExp(v);
              }
              fData = _.filter(fData, function (r) {
                return r[col] && !regex.test(String(r[col]));
              });
              break;
            case '$exists':
              fData = _.filter(fData, function (r) {
                return _.has(r, col) === v;
              });
              break;
            // date stuff
            // day,week,month,quarter,year
            case '$before': // date stuff
              v = v.toLowerCase();
              fData = _.filter(fData, function (r) {
                return (
                  r[col] && r[col] < moment().endOf(v).format('YYYY-MM-DD')
                );
              });
              break;
            case '$after': // date stuff
              v = v.toLowerCase();
              fData = _.filter(fData, function (r) {
                return (
                  r[col] && r[col] > moment().startOf(v).format('YYYY-MM-DD')
                );
              });
              break;
            case '$current': // date stuff
            case '$this': // date stuff
              v = v.toLowerCase();
              fData = _.filter(fData, function (r) {
                return (
                  r[col] &&
                  r[col] >= moment().startOf(v).format('YYYY-MM-DD') &&
                  r[col] <= moment().endOf(v).format('YYYY-MM-DD')
                );
              });
              break;
            case '$last': // date stuff
              numOf = +v.match(/\d*/)[0];
              v = v.match(/[a-z]+/)[0];
              v = v.toLowerCase();
              if (!numOf) {
                // last month etc
                fData = _.filter(fData, function (r) {
                  return (
                    r[col] &&
                    r[col] >=
                      moment().subtract(1, v).startOf(v).format('YYYY-MM-DD') &&
                    r[col] <=
                      moment().subtract(1, v).endOf(v).format('YYYY-MM-DD')
                  );
                });
              } else {
                // last 30 days
                fData = _.filter(fData, function (r) {
                  return (
                    r[col] &&
                    r[col] >=
                      moment()
                        .subtract(numOf, v)
                        .startOf(v)
                        .format('YYYY-MM-DD') &&
                    r[col] <=
                      moment().subtract(1, v).endOf(v).format('YYYY-MM-DD')
                  );
                });
              }
              break;
            case '$next': // date stuff
              numOf = +v.match(/\d*/)[0]; // could be 30Days else month
              v = v.match(/[a-z]+/)[0]; // could be 30Days else month
              v = v.toLowerCase();
              if (!numOf) {
                // next month etc
                fData = _.filter(fData, function (r) {
                  return (
                    r[col] &&
                    r[col] >=
                      moment().add(1, v).startOf(v).format('YYYY-MM-DD') &&
                    r[col] <= moment().add(1, v).endOf(v).format('YYYY-MM-DD')
                  );
                });
              } else {
                // next 30 days
                fData = _.filter(fData, function (r) {
                  return (
                    r[col] &&
                    r[col] >=
                      moment().add(1, v).startOf(v).format('YYYY-MM-DD') &&
                    r[col] <=
                      moment().add(numOf, v).endOf(v).format('YYYY-MM-DD')
                  );
                });
              }
              break;
          }
        });
      }
      if (_.isFunction(callback)) {
        callback.call(fData);
      } // call passed in callback function
    }
    return fData;
    // return me;
  }

  applyAdvFilters(theData, theFilters, callback?) {
    // based on reapplyFilters in efApi
    let filterFunctions, filterConditionals;
    let filterVals;
    _.each(theFilters, (filters, col) => {
      if (col !== 'conditionals') {
        if (!_.isArray(filters)) {
          filters = [filters];
        } // should always be in array format
        filterFunctions = _.filter(filters, function (d) {
          return _.isFunction(d);
        }); // should get just the functions
        filterConditionals = _.filter(filters, function (d, k) {
          return !_.isArray(d) && _.isObject(d) && !_.isFunction(d);
        }); // should just get the objects which are conditionals
        filterVals = _.filter(filters, function (d) {
          return !_.isFunction(d) && (_.isArray(d) || !_.isObject(d));
        }); // remove functions and objects, which should be list of values.
        if (filterVals.length) {
          theData = this.advFilter(theData, col, filterVals);
        }
        if (filterConditionals && filterConditionals.length > 0) {
          theData = this.advFilter(theData, col, filterConditionals);
        }
        _.each(filterFunctions, function (filter) {
          theData = this.advFilter(theData, col, filter);
        });
      }
    });
    if (_.isFunction(callback)) {
      callback.call(theData);
    } // call passed in callback function
    return theData;
  }

  oDifference(oldval, newval, omitKeys) {
    const oDiff = _.reduce(
      oldval,
      function (o, d, k) {
        if (newval[k] !== d) {
          o[k] = { old_val: d, new_val: newval[k] };
        }
        return o;
      },
      {},
    );
    return _.omit(oDiff, omitKeys);
  }

  upsert(arr, key, newval) {
    const match = _.find(arr, key);
    if (match) {
      // const index = _.indexOf(arr, _.find(arr, key));
      const index = _.indexOf(arr, match);
      const oDiff = _.reduce(
        match,
        function (o, d, k) {
          if (newval[k] !== d) {
            o[k] = { old_val: d, new_val: newval[k] };
          }
          return o;
        },
        _.extend({}, key),
      );
      arr.splice(index, 1, newval);
    } else {
      // log.info('upsert new value',newval);
      arr.push(newval);
    }
  }

  _ = _.extend(_, {
    guid: this.guid,
    guidLower: this.guidLower,
    coalesce: this.coalesce,
    upsert: this.upsert,
    oDifference: this.oDifference,
    advFilter: this.advFilter,
    applyAdvFilter: this.applyAdvFilters,
    formatMoney: this.formatMoney,
    addCommasToNumber: this.addCommasToNumber,
    tinyDate: this.tinyDate,
    byMulti: this.byMulti,
    pivotByMulti: this.pivotByMulti,
    indexByMulti: this.indexByMulti,
    countByMulti: this.countByMulti,
    sumByMulti: this.sumByMulti,
    groupByMulti: this.groupByMulti,
    dataToStackedBar: this.dataToStackedBar,
    campaignToSummary: this.campaignToSummary,
    moneyToBinary: this.moneyToBinary,
    param: this.param,
    distinct: this.distinct,
    isNumeric: this.isNumeric,
    capitalizeWords: this.capitalizeWords,
    stringifyNumber: this.stringifyNumber,
    shrink: this.shrink,
    unshrink: this.unshrink,
    jsonToRows: this.jsonToRows,
    rowsToJson: this.rowsToJson,
    timeIt: this.timeIt,
  });
  // _ = _.extend(_, { jsonToRows: this.jsonToRows });
  //this = _.extend(_, this);
}
